import { theme, utils as designUtils } from '@febos-io/design';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  useGetUserSettingsCallback,
  useTranslation
} from '../hooks';
import {
  clearUserSession,
  setUserMetadata
} from '../store';
import {useAuthContext} from '../providers';
import {COMPANY_SELECTOR} from '../config';

export function SignInInfoLoading() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { callback, } = useGetUserSettingsCallback();
  const { t, } = useTranslation();
  const { signInRedirectPathname, } = useAuthContext();
  const handleLoaderUserInfo = useCallback(async () => {
    try {
      console.log('LOADING INFO.');
      dispatch(clearUserSession());
      const response = await callback();
      const companies = response.info;
      if (!companies.length) {
        designUtils.error(t('you don\'t have companies or relations'));
        navigate(signInRedirectPathname);
      }
      dispatch(setUserMetadata(companies));
      navigate(COMPANY_SELECTOR);
    } catch (e) {
      designUtils.error(t('you don\'t have companies or relations'));
      console.log(e);
    }
  }, [callback, dispatch, navigate, signInRedirectPathname, t]);
  useEffect(() => {
    handleLoaderUserInfo();
  }, [handleLoaderUserInfo]);
  return <theme.views.Login>Cargando información</theme.views.Login>;
}

export default SignInInfoLoading;
